import Vue from "vue";

const menu = [
  {
    path: '/index',
    name: 'yd.menu.home',
    icon: 'icon-z-shouye1',
    level: 1,
    sort: 1,
    children: [],
    fixed: false
  },
  {
    path: '/',
    name: 'yd.menu.app_market',
    icon: 'icon-z-yingyongshichang',
    level: 0,
    permission:'/app',
    fixed: false,
    children: [
      {
        level: 1,
        permission:'/inner/app',
        path: '/appInside',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.menu_inside_app'
      },
      {
        level: 1,
        permission:'/app/check',
        path: '/appCheck',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.menu_app_check'
      },
      {
        level: 1,
        permission:'/app/appUpload',
        path: '/appUpload',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.menu_app_upload'
      },
      {
        level: 1,
        permission:'/app/shelflist',
        path: '/appList',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.applist'
      },
      {
        level: 1,
        permission:'/app/appParamConfig/list',
        path: '/appParamConfig/list',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.app_param_config'
      },
      {
        level: 1,
        permission:'/app/deploy',
        path: '/app/deploy',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.app_deploy'
      },
      {
        level: 1,
        permission:'/app/occupyScreen',
        path: '/app/occupyScreen',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.occupy_screen'
      },
    ]
  },
  {
    path: '/',
    name: 'yd.menu.group_manager',
    icon: 'icon-z-ziyuan',
    level: 0,
    permission:'/groupManage',
    children: [
      {
        path: '/groupManage',
        name: 'yd.menu.group_manager',
        icon: 'icon-z-ziyuan',
        level: 0,
        permission:'/groupManage',
        children: [],
        fixed: false,
      }
    ],
    fixed: false,
  },
  {
    path: '/',
    name: 'yd.menu.remote_manage_menu',
    icon: 'icon-z-yuanchengxiezhu',
    level: 0,
    permission:'/remote',
    fixed: false,
    children: [
      // {
      //   level: 1,
      //   permission:'/remote/remoteManage',
      //   path: '/remoteManage',
      //   icon: 'icon-z-yuandian',
      //   children: [],
      //   fixed: false,
      //   name: 'yd.menu.remote_manage_menu'
      // },
      {
        level: 1,
        permission:'/remote/remoteManage',
        path: '/remoteManage2',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.remote_manage_menu'
      },
      {
        level: 1,
        permission:'/remote/remoteConfiguration',
        path: '/remoteConfiguration',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.remote_configuration'
      },
      {
        level: 1,
        permission:'/remote/remoteUsageRecord',
        path: '/remoteUsageRecord',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.remote_usage_record'
      },
      {
        level: 1,
        permission:'/remote/remoteClearLockPass',
        path: '/remoteClearLockPass',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.device_restore'
      },
      {
        level: 1,
        permission:'/remote/appManage',
        path: '/remoteAppManage',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.remote_app_manage'
      },
      // {
      //   level: 1,
      //   permission:'/remote/remoteDeviceAddressMange',
      //   path:  '/remoteDeviceAddressMange',
      //   icon: 'icon-z-yuandian',
      //   children: [],
      //   fixed: false,
      //   name: 'yd.menu.address_manage'
      // },
      {
        level: 1,
        path: '/deviceConfig',
        permission:'/remote/deviceConfig',
        children: [],
        icon: 'icon-z-yuandian',
        fixed: false,
        name: 'yd.menu.device_config'
      },


    ]
  },
  {
    path: '/',
    name: 'yd.menu.dataCenter',
    icon: 'icon-z-shujuzhongxin',
    level: 0,
    permission:'/dataCenter',
    fixed: false,
    children: [
      {
        level: 1,
        permission:'/dataCenter/myDevice',
        path: '/myDevice',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.my_device'
      },
      // {
      //   level: 1,
      //   permission:'/dataCenter/deviceMap',
      //   path:'/deviceMap',
      //   icon: 'icon-z-yuandian',
      //   children: [],
      //   fixed: false,
      //   name: 'yd.menu.deviceMap'
      // },
      {
        level: 1,
        permission:'/dataCenter/deviceAppInfo',
        path: '/deviceAppInfo',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.device_app_info'
      },
      {
        level: 1,
        path: '/deviceLifeCycle',
        permission:'/dataCenter/deviceLifeCycle',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.device_life_cycle'
      },
      {
        level: 1,
        path: '/flowManage',
        permission:'/dataCenter/flowManage',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false,
        name: 'yd.menu.flow_manage'
      },
      // {
      //   level: 1,
      //   path: '/visitInfoStatistic',
      //   permission:'/dataCenter/myDevice',
      //   icon: 'icon-z-yuandian',
      //   children: [],
      //   fixed: false,
      //   name: 'yd.menu.visitInfoStatistic'
      // },
      // {
      //   level: 1,
      //   path: '/abnormalAlarmStatistics',
      //   permission:'/dataCenter/myDevice',
      //   icon: 'icon-z-yuandian',
      //   children: [],
      //   fixed: false,
      //   name: 'yd.menu.abnormalAlarmStatistics'
      // },



    ]
  },
  {
    path: '/deviceAttribution',
    name: 'yd.menu.devicedistributionmanage',
    icon: 'icon-z-shebeiguishuguanli',
    level: 0,
    permission:'/deviceAttribution',
    fixed: false,
    children: [
      {
        level: 1,
        path: '/deviceAttribute',
        icon: 'icon-z-yuandian',
        permission:'/deviceAttribution/attribute',
        children: [],
        fixed: false,
        name: 'yd.menu.devicedistribution'
      },

    ]
  },

  // {
  //   path: '/sysCustomization',
  //   name: 'yd.menu.sysCustomization',
  //   icon: 'icon-z-xitongshezhi',
  //   level: 0,
  //   permission:'/sysCustomization',
  //   fixed: false,
  //   children: [
  //
  //     {
  //       level: 1,
  //       path: '/customDesk',
  //       icon: 'icon-z-yuandian',
  //       permission:'/sysCustomization/customDesk',
  //       children: [],
  //       fixed: false,
  //       name:  'yd.menu.customDesk'
  //     }
  //   ]
  // },

  {
    path:'/account',
    name:'yd.menu.account_manage',
    icon: 'icon-z-zhanghaoguanli',
    level: 0,
    permission:'/accountManage',
    sort: 1,
    children: [
      {
        path: '/companyInfo',
        name: 'yd.menu.company_info',
        level: 1,
        permission:'/accountManage/companyInfo',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false
      },
      {
        path: '/personalInfo',
        name: 'yd.menu.personal_info',
        level: 1,
        permission:'/accountManage/personalInfo',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false
      },
      {
        path: '/myOperator',
        name: 'yd.menu.my_operator',
        level: 1,
        permission:'/accountManage/myOperator',
        icon: 'icon-z-yuandian',
        children: [],
        fixed: false
      }
    ]
  },

  {
   path: '/',
   name: 'yd.menu.device',
   icon: 'icon-z-pingtaishebeiguanli',
   permission: '/device/list',
   level: 0,
   fixed: false,
   children: [
     {
       level: 1,
       path: '/deviceList',
       permission: '/device/list',
       children: [],
       icon: 'icon-z-yuandian',
       fixed: false,
       name: 'yd.menu.devicelist'
     },
   ]
  },
  {
    path: '/',
    name: 'yd.menu.sysCustomization',
    icon: 'icon-z-xitongshezhi',
    level: 0,
    permission: '/sysCustomization',
    fixed: false,
    children: [
      {
        level: 1,
        path: '/sysCustomization/bootAnimation',
        icon: 'icon-z-yuandian',
        permission:'/sysCustomization/bootAnimation',
        children: [],
        fixed: false,
        name: 'deviceConfig.bootAnimation.tab_name'
      },
      {
        level: 2,
        path: '/sysCustomization/bootLogo',
        icon: 'icon-z-yuandian',
        permission:'/sysCustomization/bootLogo',
        children: [],
        fixed: false,
        name: 'deviceConfig.bootLogo.tab_name'
      },
    ]
  },
  {
   path: '/',
   name: 'yd.menu.organization_management',
   icon: 'icon-z-zuzhijiegou',
   permission: '/organizationManagement',
   children: [
     {
       path: '/organizationManagement',
       permission: '/organizationManagement/organizationManagement',
       icon: 'icon-z-yuandian',
       name: 'yd.menu.organization_management_another',
       children: []
     },
     {
       path: '/orgRepository',
       permission: '/organizationManagement/orgRepository',
       icon: 'icon-z-yuandian',
       name: 'yd.menu.organization_management_repository',
       children: []
     },
   ]
  },
  // {
  //   path: '/',
  //   name: 'yd.menu.manufacturer_management',
  //   icon: 'icon-z-pingtaishebeiguanli',
  //   permission: '/manufacturer',
  //   children: [
  //     {
  //       path: '/manufacturer',
  //       permission: '/manufacturer/queryManufacturers',
  //       icon: 'icon-z-yuandian',
  //       name: 'yd.menu.manufacturer_dvc_type',
  //       children: []
  //     },
  //   ]
  // },

  //设备管理
  {
    path: '/',
    name: 'yd.menu.device',
    icon: 'icon-z-pingtaishebeiguanli',
    permission: '/device',
    children: [
      {
        path: '/device',
        permission: '/device/deviceList',
        icon: 'icon-z-yuandian',
        name: 'yd.menu.device_detail',
        children: []
      },{
        path: '/device/tasks',
        permission: '/device/tasks',
        icon: 'icon-z-yuandian',
        name: 'yd.menu.device_task',
        children: []
      },{
        path: '/device/ota',
        permission: '/device/ota',
        icon: 'icon-z-yuandian',
        name: 'yd.menu.ota',
        children: []
      },
      {
        path: '/manufacturer',
        permission: '/manufacturer',
        icon: 'icon-z-yuandian',
        name: 'yd.menu.manufacturer_dvc_type',
        children: []
      },
      {
        path: '/device/lifeCycle',
        permission: '/device/lifeCycle',
        icon: 'icon-z-yuandian',
        name: 'yd.menu.device_life_cycle',
        children: []
      },
      {
        path: '/device/logManage',
        permission: '/device/logManage',
        icon: 'icon-z-yuandian',
        name: 'yd.menu.log_manage',
        children: []
      }
    ]
  },
  {
    path: '/',
    name: 'yd.menu.basesetting',
    icon: 'icon-z-peizhishezhi',
    permission: '/setting',
    children: [
      {
        path: '/platformSettings',
        permission: '/setting/platformSetting',
        icon: 'icon-z-yuandian',
        name: 'yd.menu.platform_settings',
        children: []
      },
      {
        path: '/operationLog',
        permission: '/setting/operationLog',
        icon: 'icon-z-yuandian',
        name: 'yd.menu.operation_log',
        children: []
      },
      {
        path: '/authorityManagement',
        permission: 'authorityManagement',
        icon: 'icon-z-yuandian',
        name: 'yd.menu.authority_management',
        children: []
      },

    ]
  },

  /*{
    path: '/remoteAssistance',
    name: 'yd.menu.remote_assistance',
    icon: 'icon-z-pingtaishebeiguanli',
    //permission: '/device/list',
    level: 0,
    fixed: false,
    children: [
      {
        level: 1,
        path: '/deviceConfig',
        //permission: '/device/list',
        children: [],
        icon: 'icon-z-yuandian',
        fixed: false,
        name: 'yd.menu.device_config'
      },
    ]
  },*/

]

export default menu



// WEBPACK FOOTER //
// ./src/router/menu.js